import { render } from "./TeamTransactionsGrid.vue?vue&type=template&id=0e4810d3&scoped=true"
import script from "./TeamTransactionsGrid.vue?vue&type=script&lang=js"
export * from "./TeamTransactionsGrid.vue?vue&type=script&lang=js"

import "./TeamTransactionsGrid.vue?vue&type=style&index=0&id=0e4810d3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0e4810d3"

export default script